import React     from 'react';
import { Link }  from 'react-router-dom';
import PropTypes from 'prop-types';

import AlbumDescriptionButtonsItem from './AlbumDescriptionButtonsItem';
import AlbumDescriptionDetails     from './AlbumDescriptionDetails';
import AlbumDescriptionSocialShare from './AlbumDescriptionSocialShare';
import Gallery                     from '../../Gallery/Gallery';
import MediaPin                    from '../../Favorite/Actor/MediaPin';

import { dislikeMedia, likeMedia } from '../../ActorMediaVotingActions';
import Flux 		               from '../../../flux/Flux';
import { generateKey }             from '../../../utils/CommonUtils';
import Translations                from '../../../utils/Translations';
import UrlBuilder                  from '../../../utils/UrlBuilder';

const ActorPromotedVideo = (props) => {

    const {
        actorId,
        actorName,
        commentsTotalCount,
        isModelFavorite,
        onGalleryClick,
        onVip30Click,
        promotedVideo,
        selectedTagGroup,
        setPromotedVideo
    } = props;

    const {
        areCommentsVisible,
        dislikes,
        isVotingVisible,
        likes,
        videoTags
    } = promotedVideo;

    const [showSocialShare, setShowSocialShare] = React.useState(false);

    const needsGuestAccess = !Flux.Guest.isLoggedIn() || promotedVideo?.needAvs || promotedVideo?.needVip;
    const baseClassName    = 'profile-video-details--description';

    const userVotingHandler = {

        handleOnLikeClick: () => {
            const updatedLikes    = promotedVideo.isLiked ? likes - 1 : likes + 1;
            const updatedDislikes = promotedVideo.isDisliked ? dislikes - 1 : dislikes;
            setPromotedVideo({
                ...promotedVideo,
                isLiked:    !promotedVideo.isLiked,
                likes:      updatedLikes,

                isDisliked: false,
                dislikes:   updatedDislikes
            });

            likeMedia(actorId, promotedVideo.id);
        },

        handleOnDislikeClick: () => {
            const updatedLikes    = promotedVideo.isLiked ? likes - 1 : likes;
            const updatedDislikes = promotedVideo.isDisliked ? dislikes - 1 : dislikes + 1;

            setPromotedVideo({
                ...promotedVideo,
                isDisliked: !promotedVideo.isDisliked,
                dislikes:   updatedDislikes,

                isLiked:    false,
                likes:      updatedLikes
            });
            dislikeMedia(actorId, promotedVideo.id);
        },

        handleOnSocialShareClick: () => {
            setShowSocialShare(!showSocialShare);
        }
    };

    return (
        <section className="container-block">
            <div className="context-box--actor-profile">
                <span className="context-box__title" dangerouslySetInnerHTML={{ __html: Translations.get('ProfileVideoPromoted') }} />
            </div>

            <div className="context-box--motive-panel clearfix -padding-sm">
                <div className="col-xs-12 col-sm-12 col-lg-7 profile-videos--video-margin-fix">
                    <div className="context-box--motive -padding-sm">
                        <div className="box--fixed-ratio -ratio16_9">
                            <div className="box--fixed-ratio__content gallery__frame has-dark-poster">
                                <Gallery
                                    actorId={actorId}
                                    initialVideos={[promotedVideo]}
                                    isModelGuestFavorite={isModelFavorite}
                                    onShowModal={needsGuestAccess ? onGalleryClick : null}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-lg-5 profile-videos--description">

                    <span className="profile-videos--description-title" dangerouslySetInnerHTML={{__html: promotedVideo.albumTitle}}/>

                    <div id="profile-videos--description-info" className="profile-videos--description-info">
                        <div className={baseClassName + '-text'} dangerouslySetInnerHTML={{__html: promotedVideo.description}} />
                        <div className={baseClassName + '-complex-wrapper'}>
                            <AlbumDescriptionDetails
                                actorName         = {actorName}
                                baseClassName     = {baseClassName + '-complex'}
                                contestPlace      = {promotedVideo.contestPlace}
                                contestDetailsUrl = {promotedVideo.contestDetailsUrl}
                                duration          = {promotedVideo.duration}
                                hasAudio          = {promotedVideo.hasAudio}
                                releaseDate       = {promotedVideo.releaseDate}
                                totalViews        = {promotedVideo.totalViews}
                            />

                            <div className={(!isVotingVisible ? ' jf-right' : '')}>
                                <div className = {baseClassName + '-complex-share'}>
                                    <div className = {baseClassName + '-complex-share__actions'}>
                                        {isVotingVisible && Flux.Guest.isLoggedIn() && <>

                                            <AlbumDescriptionButtonsItem
                                                baseClassName = {baseClassName + '-complex-share__actions'}
                                                checkable     = {false}
                                                checked       = {promotedVideo.isLiked}
                                                icon          = "-icon-like-line"
                                                iconChecked   = "-icon-like-full"
                                                onClick       = {userVotingHandler.handleOnLikeClick}
                                                text          = {promotedVideo.likes}
                                                tooltipText   = {Translations.get('LikeTooltip')}
                                            />

                                            <AlbumDescriptionButtonsItem
                                                baseClassName = {baseClassName + '-complex-share__actions'}
                                                checkable     = {false}
                                                checked       = {promotedVideo.isDisliked}
                                                icon          = "-icon-unlike-line"
                                                iconChecked   = "-icon-unlike-full"
                                                onClick       = {userVotingHandler.handleOnDislikeClick}
                                                text          = {promotedVideo.dislikes}
                                                tooltipText   = {Translations.get('DislikeTooltip')}
                                            />

                                            {(areCommentsVisible && (commentsTotalCount > 0)) &&
                                                <AlbumDescriptionButtonsItem
                                                    baseClassName = {baseClassName + '-complex-share__actions'}
                                                    checkable     = {false}
                                                    icon          = "-icon-chat-flat-line"
                                                    iconChecked   = "-icon-chat-flat"
                                                    text          = {commentsTotalCount}
                                                    tooltipText   = {Translations.get('CommentTooltip')}
                                                />
                                            }
                                        </> }
                                        <MediaPin
                                            actorId           = {actorId}
                                            albumId           = {promotedVideo.id}
                                            fontSize          = ""
                                            initialIsFavorite = {!!(promotedVideo.isFavoriteAlbum || promotedVideo.isFavorite || promotedVideo.pinned)}
                                            tooltipPlacement  = "top"
                                        />
                                        <AlbumDescriptionButtonsItem
                                            baseClassName = {baseClassName + '-complex-share__actions'}
                                            checkable     = {false}
                                            icon          = "-icon-share-icon-line"
                                            iconChecked   = "-icon-share-icon"
                                            onClick       = {userVotingHandler.handleOnSocialShareClick}
                                            tooltipText   = {Translations.get('ShareTooltip')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

					<AlbumDescriptionSocialShare
					    album         = {promotedVideo}
                        baseClassName = {baseClassName + '-complex-share-contents'}
					    isVisible     = {showSocialShare}
                    />

                    <div className="profile-video-details--description-tags">
                        <div className="profile-video-details--description-tags-list">
                            {promotedVideo.isVip30 &&
                                <span className="profile-video-details--description-tags-list-item profile-video-details--description-tags-list-item--gold">
                                    <a className="profile-video-details--description-tags-list-item-tag profile-video-details--description-tags-list-item-tag--gold"
                                        href={UrlBuilder.buildVIP30Url()}
                                        onClick={onVip30Click}
                                        dangerouslySetInnerHTML={{ __html: Translations.get('VIP30TAG') }}
                                    />
                                </span>
                            }

                            {videoTags && videoTags.length > 0 && videoTags.map((tag, idx) => (
                                <Link
                                    to = {selectedTagGroup === tag
                                        ? UrlBuilder.buildActorProfileVideosUrl(actorName)
                                        : (UrlBuilder.buildActorProfileVideosUrl(actorName) + "?tag=" + tag)
                                    }
                                    key       = {generateKey('tag', idx)}
                                    className = {"profile-video-details--description-tags-list-item " + (selectedTagGroup === tag ? "selected" : "")}
                                >
                                    <span className="profile-video-details--description-tags-list-item-tag" >{tag}</span>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

ActorPromotedVideo.propTypes = {
    actorId:            PropTypes.number,
    actorName:          PropTypes.string,
    commentsTotalCount: PropTypes.number, // from HOC withGalleryComments
    isModelFavorite:    PropTypes.bool,
    onGalleryClick:     PropTypes.func,
    onVip30Click:       PropTypes.func,
    promotedVideo:      PropTypes.object,
    selectedTagGroup:   PropTypes.string,
    setPromotedVideo:   PropTypes.func,
};

export default ActorPromotedVideo;
